import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
import { CheckCircle2, XCircle, RefreshCw, HelpCircle } from 'lucide-react';
const loop = ['Path found', 'Fix recommended', 'Ticket created', 'Remediation done', 'Validation re-run', 'Risk verified closed', 'Evidence stored'];
const outcomes = [{
  icon: CheckCircle2,
  label: 'Fixed',
  color: '#22c55e',
  desc: 'Risk fully closed. Evidence captured.'
}, {
  icon: XCircle,
  label: 'Still exposed',
  color: '#ef4444',
  desc: 'Remediation did not close the risk.'
}, {
  icon: RefreshCw,
  label: 'Reopened by drift',
  color: '#f97316',
  desc: 'Was fixed, now exposed again.'
}, {
  icon: HelpCircle,
  label: 'Inconclusive',
  color: '#a78bfa',
  desc: 'More information needed to verify.'
}];
export function Verification() {
  return <section id="verification" className="relative w-full py-32 border-t border-white/5" data-id="element-881">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-882">
        <SectionLabel number="11" label="Fix Verification" className="mb-8" data-id="element-883" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-884">
          <div className="lg:col-span-8" data-id="element-885">
            <SectionHeading size="xl" data-id="element-886">
              Closed tickets are
              <br data-id="element-887" />
              <span className="text-white/40" data-id="element-888">not closed risk.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-4 lg:pt-4" data-id="element-889">
            <p className="text-base text-white/60 leading-relaxed" data-id="element-890">
              Most security tools stop when a finding is created. Periscan
              closes the loop and turns remediation from an assumption into
              proof.
            </p>
          </div>
        </div>

        {/* Loop — horizontal connected steps */}
        <div className="mb-20" data-id="element-891">
          <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-8" data-id="element-892">
            The Loop
          </p>
          <div className="relative grid grid-cols-1 md:grid-cols-7 gap-2" data-id="element-893">
            {loop.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.08
          }} className="relative p-4 rounded-xl bg-[#0a0d12] border border-white/[0.06] hover:border-[#1a8fd4]/40 transition-colors" data-id="element-894">
                <span className="font-mono text-[10px] text-[#1a8fd4]/60 mb-2 block" data-id="element-895">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <p className="text-sm text-white font-medium leading-snug" data-id="element-896">
                  {step}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Outcomes — focused card grid (4 instead of 7) */}
        <div data-id="element-897">
          <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-8" data-id="element-898">
            Verification Outcomes
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-899">
            {outcomes.map((o, i) => {
            const Icon = o.icon;
            return <motion.div key={i} initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.35,
              delay: i * 0.06
            }} className="p-6 rounded-xl bg-[#070a0e] border border-white/[0.06] hover:border-white/15 transition-colors" data-id="element-900">
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center mb-4" style={{
                backgroundColor: `${o.color}1a`,
                boxShadow: `0 0 16px ${o.color}33`
              }} data-id="element-901">
                    <Icon className="w-4 h-4" style={{
                  color: o.color
                }} data-id="element-902" />
                  </div>
                  <h4 className="text-base font-semibold text-white mb-1.5" data-id="element-903">
                    {o.label}
                  </h4>
                  <p className="text-sm text-white/55 leading-relaxed" data-id="element-904">
                    {o.desc}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}